// extracted by mini-css-extract-plugin
export default {"cred_label":"add-gcp-firewall_cred_label__32RmX"};